import { OperatorTypeEnum } from 'src/app/enums/operatorType.enum';

export function buildOperatorKey(condition: OperatorTypeEnum, field: string): string {
    return `OperatorTypeEnum.${condition}_${field}`;
}
